module.exports = __webpack_public_path__ + "static/media/expandedSVG.6e36d8ba.svg";